import { useEffect, useState } from "react";
import api from "@/lib/api";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Button } from "@/components/ui/button";
import { FileText, DownloadSimple, ArrowLeft } from "@phosphor-icons/react";

export default function Documents() {
  const [docs, setDocs] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { api.get("/docs").then((r) => setDocs(r.data)); }, []);

  const open = async (slug) => {
    const { data } = await api.get(`/docs/${slug}`);
    setActive(data);
  };

  const download = (doc) => {
    const blob = new Blob([doc.content], { type: "text/markdown" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = doc.file; a.click();
    URL.revokeObjectURL(url);
  };

  if (active) {
    return (
      <div className="space-y-6">
        <button onClick={() => setActive(null)} className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-terracotta"><ArrowLeft /> Tous les documents</button>
        <div className="flex flex-wrap items-center justify-between gap-3">
          <h1 className="font-display text-2xl font-extrabold">{active.title}</h1>
          <Button data-testid="doc-download" onClick={() => download(active)} className="rounded-full bg-forest text-white hover:bg-forest/90"><DownloadSimple className="mr-1.5" /> Télécharger (.md)</Button>
        </div>
        <div className="prose-yaya rounded-2xl border border-border bg-white p-6 text-sm"><ReactMarkdown remarkPlugins={[remarkGfm]}>{active.content}</ReactMarkdown></div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div className="animate-fade-up">
        <span className="text-xs font-semibold uppercase tracking-[0.25em] text-terracotta">Livrables stratégiques</span>
        <h1 className="mt-2 font-display text-3xl font-extrabold sm:text-4xl">Documents</h1>
        <p className="mt-1 text-ink/65">Cahier des charges, business plan, marketing & lancement, organisation.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        {docs.map((d) => (
          <div key={d.slug} data-testid={`doc-${d.slug}`} className="group flex items-center gap-4 rounded-2xl border border-border bg-white p-5 transition hover:-translate-y-1 hover:shadow-[0_14px_34px_rgba(4,42,101,0.1)]">
            <div className="grid h-12 w-12 place-items-center rounded-xl bg-terracotta/10 text-terracotta"><FileText size={26} weight="duotone" /></div>
            <div className="flex-1">
              <div className="font-display font-bold">{d.title}</div>
              <div className="text-xs text-muted-foreground">{d.file}</div>
            </div>
            <Button variant="outline" onClick={() => open(d.slug)} className="rounded-full" data-testid={`doc-open-${d.slug}`}>Ouvrir</Button>
          </div>
        ))}
      </div>
    </div>
  );
}
